module.exports = __webpack_public_path__ + "static/media/skype.3c9ff74a.svg";